import React from "react";
import {connect} from "react-redux";
import {Dimensions, Image, StyleSheet, Text, TouchableOpacity, View} from "react-native";
import AvatarIcon from "../Header/AvatarIcon";
import ModifierCerclePicto from "../Picto/ModifierCerclePicto";
import ReglageCerclePicto from "../Picto/ReglageCerclePicto";
import BoutonTextPictoRight from "../Bouton/BoutonTextPictoRight";
import MailPicto from "../Picto/MailPicto";
import FocusActivePicto from "../Picto/FocusActivePicto";
import SignetActivePicto from "../Picto/SignetActivePicto";
import PostList from "../Feed/PostFeed/PostList";
import {getAuthorFeed, getFeedNormal, getMyProfil, getProfil, login} from "../../API/API";
import MessageCerclePicto from "../Picto/MessageCerclePicto";
import FocusCerclePicto from "../Picto/FocusCerclePicto";
import AppLoadingPlaceholder from "expo/build/launch/AppLoadingPlaceholder";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import RichText from "../Shared/RichText";
import {wrapAction, wrapStyle} from "../../sw/helpers";

class ProfilScreen extends React.Component{
    constructor(props) {
        super(props);

        this.state={
            isMyProfil : (this.props.route.params==undefined || this.props.route.params.idProfil==undefined),
            isUser: false,
            isContact: ( this.props.route.params!=undefined && this.props.route.params.idProfil!=undefined),
            isRefresh : false,
            nextCursor : undefined,
            feed : [],
            isLoad:true,
            bookmark:[],
            compte : undefined
        }
        this.getMyFeed = this.getMyFeed.bind(this);
        this.navigateToFocusScreen = this.navigateToFocusScreen.bind(this);
        this.navigateToReglageScreen = this.navigateToReglageScreen.bind(this);
        this.navigateToEditProfilScreen = this.navigateToEditProfilScreen.bind(this);
        this.goToMessage = this.goToMessage.bind(this);
        this.setHeader = this.setHeader.bind(this);
    }
    refresh(){
    }

    getProfil(){
        if(this.state.isMyProfil) {
            this.getMyProfil();
        }else{
            this.getProfilContact(this.props.route.params.idProfil);
        }
    }

    getMyProfil(){
        getMyProfil().then(data=>{
            let compte=data;
            const action = {'type': 'SIGN_IN', 'value': compte};
            this.props.dispatch(action);
            this.setState({
                compte:data,
                isLoad:false
            });
        });
    }

    getProfilContact(id){
        getProfil(id).then(data=>{
            this.setState({
                compte:data,
                isLoad:false,
            });
            this.setHeader();
        });
    }

    componentDidMount() {
        this.props.navigation.addListener("focus",e=>{

            this.getMyFeed();
            this.getProfil();
        });

        if(this.state.isMyProfil){
            this.hideHeader()
        }
    }

    hideHeader(){
        this.props.navigation.setOptions(
            {
                headerShown:false,
            }
        );
    }

    getMyFeed(){
        if(this.state.currentCursor!==false){
            this.setState({
                isLoading: true
            });
            let id;
            if(!this.state.isMyProfil && this.props.route.params.idProfil!=undefined){
                id = this.props.route.params.idProfil;
            }else{
                id = this.props.auth.compte.id;
            }
            getAuthorFeed(id,this.state.currentCursor).then(data => {
                if(data=="Not Acceptable"){
                    this._deconnexion();
                }

                let d = this.uniqueArray(this.state.feed,data.data);
                let feed = this.state.feed.concat(d) ;

                this.setState({
                    currentCursor : data.cursor,
                    feed : feed,
                    isLoading: false
                });
            });
        }
    }

    getBookmark(){
        getBookmark().then(data=>{
            this.state.bookmark = data
        });
    }

    uniqueArray(arr1,arr2){
        let ids  = arr1.map((item)=>{return item.id});
        return  arr2.filter((item) =>{return !ids.includes(item.id);});
    }

    navigateToFocusScreen(){
        this.props.navigation.navigate("MyFocus",{});
    }

    navigateToBookmarkScreen(){
        this.props.navigation.navigate("Bookmark",{});
    }

    navigateToReglageScreen(){
        this.props.navigation.navigate("Reglage",{});
    }

    navigateToEditProfilScreen(){
        this.props.navigation.navigate("editProfil",{});
    }

    goToMessage(){

        const jid = "user-"+this.props.route.params.idProfil+"@localhost";
        window._converse.api.contacts.add(jid);
        window._converse.api.chats.open(jid,[],true).then(chat=>{
            this.props.navigation.navigate("Message",{});
        });
    }

    setHeader(){
        const styleHeaderGlobal = {
            shadowOpacity: 0,
            shadowRadius: 0,
            borderWidth:0,
            elevation: 0,
            borderColor:"transparent" ,
            borderBottomWidth:0,
            fontFamily: this.props.theme.fonts.title,
            backgroundColor : this.props.theme.colors.tertiary.grey3.value,
            height:80
        }  ;


        this.props.navigation.setOptions(
            {
                headerTitle:this.state.compte.firstname + " " + this.state.compte.lastname,
                title : this.state.compte.firstname + " " + this.state.compte.lastname,
                headerRight :"",
                headerShown:true,
                headerStyle: styleHeaderGlobal,
                headerLeft : ()=><TouchableOpacity onPress={this.props.navigation.goBack}>
                    <Image resizeMode={"contain"} style={{width:20,marginLeft:10,height: 20, flex: 1}} source={this.props.theme.pictos.chevronGaucheMediumPicto.light} />
                </TouchableOpacity>
            }
        );
    }

    render_header(styles){
        const user = this.state.compte;
        if(this.state.isLoad){
            return <AppLoadingPlaceholder/>;
        }
        return (
            <View>
            <View style={styles.headerContainer}>
            <View style={styles.avatarButtonContainer}>
                <AvatarIcon icon={user.img} style={{width:60, height:60,borderWidth:0,borderRadius:24}} />
                <View style={styles.topButtonContainer}>
                    {this.state.isMyProfil==true &&
                      <View style={{flexDirection:"row"}}>
                        <TouchableOpacity onPress={wrapAction(this.navigateToEditProfilScreen)} style={wrapStyle({})}>
                            <ModifierCerclePicto style={styles.topButton} isHeader={true}/>
                        </TouchableOpacity>
                        <TouchableOpacity onPress={this.navigateToReglageScreen}>
                            <ReglageCerclePicto style={styles.topButton} isHeader={true}/>
                        </TouchableOpacity>
                      </View>
                    }
                    {this.state.isContact==true && (<TouchableOpacity onPress={this.goToMessage}>
                        <MessageCerclePicto style={styles.topButton} isHeader={true}/>
                    </TouchableOpacity> )
                    }
                    {this.state.isUser==true &&   (<TouchableOpacity>
                        <FocusCerclePicto style={styles.topButton} isHeader={true}/>
                    </TouchableOpacity> )
                    }
                </View>
            </View>
            <Text style={styles.nomText}>{ user.firstname } { user.lastname }</Text>
            <Text style={styles.biographyText}><RichText text={ user.biography } /></Text>
            <View style={styles.mailContainer}>
                <MailPicto isHeader={true} style={{width:15,marginRight:5}} />
                <Text style={styles.textMail}>{ user.email }</Text>
            </View>
            <View style={styles.botButtonContainer}>
                {
                  this.state.isMyProfil==true &&
                  <>
                    <BoutonTextPictoRight onPress={()=>{this.navigateToFocusScreen();}} bold={true} isRed={false}
                      title={"Mes focus"} style={{containerWidth : {width: 160}}} picto={<FocusActivePicto isBouton={true}/>} />
                    <BoutonTextPictoRight onPress={()=>{this.navigateToBookmarkScreen();}} bold={true} isRed={false}
                      title={"Mes signets"} style={{containerWidth : {width: 160}}} picto={<SignetActivePicto isBouton={true}/>} />
                  </>
                }
            </View>
        </View>
        <View style={{width:'100%',justifyContent:"center",alignItems:"center",position:"absolute",bottom:3,zIndex:2}}>
            <View style={styles.separator}></View>
        </View>
    </View>)
    }

    render() {
        // avoid at render...
        const { height } = Dimensions.get('window');

        const styles=StyleSheet.create({
            container:{
            },
            headerContainer:{
                backgroundColor:this.props.theme.colors.primary.White.value,
                borderBottomLeftRadius:10,
                borderBottomRightRadius:10,
                marginBottom:15,
                position:"relative",
                zIndex:3,
                maxHeight: "50vh",
                display: "flex"
            },
            avatarButtonContainer:{
                flexDirection:"row",
                marginTop:25,
                marginBottom:20,
                marginHorizontal:20,
                justifyContent:"space-between",
                alignItems:"center"
            },
            topButtonContainer:{
                flexDirection:"row",
                justifyContent:"space-between",
                alignItems:"center"
            },
            topButton:{
                //marginHorizontal:5,
                width:50
            },
            nomText:{
                fontFamily:this.props.theme.fonts.title,
                fontSize:15,
                marginBottom:5,
                color:this.props.theme.colors.tertiary.black1.value,
                marginHorizontal:20,
            },
            biographyText:{
                fontFamily:this.props.theme.fonts.text,
                fontSize:14,
                marginBottom:10,
                color:this.props.theme.colors.tertiary.black1.value,
                flexShrink: 1,
                overflow: "scroll",
                marginHorizontal:20,
            },
            mailContainer:{
                flexDirection:"row",
                alignItems:"center",
                marginHorizontal:20
            },
            textMail : {
                color:this.props.theme.colors.primary.blue1.value,
                fontSize:15,
                fontFamily:this.props.theme.fonts.text,
            },
            botButtonContainer:{
                flexDirection:"row",
                alignItems:"center",
                justifyContent:"space-between",
                marginHorizontal:20
            },
            separator:{
                width:"95%",
                borderRadius:50,
                height:26,
                backgroundColor:this.props.theme.colors.primary.blue1.value,

            },
            feedContainer:{
                marginTop:20,
                height:height-380
            }

        });
        return (
            <PostList bookmark={this.state.bookmark} setBookmak={this.setBookmark} header={this.render_header(styles)}
                      isExplorer={false} isActive={false} refNavigation={this.props.navigation} route={this.props.route}
                      isRefresh={{}} loadMore={this.getMyFeed} refresh={this.refresh}  data={this.state.feed}
                      isProfile={true} />
        );
    }
}

const mapStateToProps = (state) => {
    return {
      isDark: state.changeTheme.isDark, theme: state.changeTheme.theme, auth: state.AuthReducer,
      online: state.sw_reducer.online
    };
}


export default compose(withTranslation(),connect(mapStateToProps))(ProfilScreen);
